/*
  TEKTO: runs the theme's jQuery code once jQuery has loaded.

  jQuery, Slick and custom.js load with "defer", so the browser can draw the page without waiting for them.
  Inline scripts that use jQuery are written as <script type="text/tk-jquery">, which the browser skips while the
  page loads. This file is loaded last in layout/theme.liquid (also with "defer", so jQuery, Slick and custom.js
  have run by now). It runs those scripts in page order, before DOMContentLoaded, so $(document).ready(...) and
  $(window).on('load', ...) inside them still fire as before.

  New jQuery code in a section: write it as <script type="text/tk-jquery">...</script>,
  or wrap it in window.tkOnJquery(function ($) { ... }).
*/
(function () {
  function runIn(container) {
    var scripts = container.querySelectorAll('script[type="text/tk-jquery"]');
    for (var i = 0; i < scripts.length; i++) {
      var original = scripts[i];
      var copy = document.createElement('script');
      copy.text = original.text;
      original.parentNode.replaceChild(copy, original);
    }
  }

  runIn(document);

  window.tkJqReady = true;
  var queue = window.tkJqQueue || [];
  window.tkJqQueue = [];
  for (var j = 0; j < queue.length; j++) {
    try {
      queue[j](window.jQuery);
    } catch (error) {
      setTimeout((function (e) { return function () { throw e; }; })(error));
    }
  }

  // Theme editor: run the scripts of a section again after it is edited.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) runIn(event.target);
  });
})();
